const materials = [
  {
    id: 1,
    title: "Java Programming Notes",
    description: "Core Java Complete Notes",
    type: "pdf",
    file: "/materials/pdf/java.pdf",
    icon: "pdf",
  },
  {
    id: 2,
    title: "Spring Boot Guide",
    description: "Spring Boot Complete Notes",
    type: "pdf",
    file: "/materials/pdf/springboot.pdf",
    icon: "pdf",
  },
  {
    id: 3,
    title: "React.js Notes",
    description: "React Beginner to Advanced",
    type: "pdf",
    file: "/materials/pdf/react.pdf",
    icon: "pdf",
  },
  {
    id: 4,
    title: "Java Interview Questions",
    description: "Most Frequently Asked Questions",
    type: "doc",
    file: "/materials/docs/interview.docx",
    icon: "doc",
  },
  {
    id: 5,
    title: "React Introduction",
    description: "React Beginner Video",
    type: "video",
    file: "/materials/videos/react.mp4",
    icon: "video",
  },
  {
    id: 6,
    title: "Spring Boot CRUD",
    description: "Spring Boot CRUD Tutorial",
    type: "video",
    file: "/materials/videos/springboot.mp4",
    icon: "video",
  },
  {
    id: 7,
    title: "SQL Notes",
    description: "Complete SQL Notes",
    type: "pdf",
    file: "/materials/pdf/sql.pdf",
    icon: "pdf",
  },
  {
    id: 8,
    title: "HTML & CSS Notes",
    description: "Frontend Development Notes",
    type: "pdf",
    file: "/materials/pdf/htmlnotes.pdf",
    icon: "pdf",
  },
];

export default materials;